import React from 'react';
import PropTypes from 'prop-types';

import Scrubber from './scrubber';
import Filler from './filler';

const Scrubbers = (props) => {
  const {
    startTime,
    endTime,
    onStartChange,
    onEndChange,
  } = props;

  return (
    <>
      <Scrubber
        time={startTime}
        onChange={onStartChange}
      />
      <Filler startTime={startTime} endTime={endTime} />
      <Scrubber
        time={endTime}
        onChange={onEndChange}
      />
    </>
  );
};

Scrubbers.propTypes = {
  startTime: PropTypes.number.isRequired,
  endTime: PropTypes.number.isRequired,
  onStartChange: PropTypes.func,
  onEndChange: PropTypes.func,
};

Scrubbers.defaultProps = {
  onStartChange: null,
  onEndChange: null,
};

export default Scrubbers;
